import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="text-area-auto-resize"
export default class extends Controller {
  static targets = ['textarea']

  connect () {
    this.resize()
    document.addEventListener('turbo:render', this.handleResize)
    document.addEventListener('turbo:morph', this.handleResize)
    document.addEventListener('turbo:morph-element', this.handleMorphElement)
  }

  disconnect () {
    document.removeEventListener('turbo:render', this.handleResize)
    document.removeEventListener('turbo:morph', this.handleResize)
    document.removeEventListener('turbo:morph-element', this.handleMorphElement)
  }

  handleResize = () => this.resize()

  handleMorphElement = (event) => {
    if (this.element.contains(event.target)) {
      this.resize()
    }
  }

  resize () {
    this.textareaTarget.style.height = 'auto'
    this.textareaTarget.style.height = `${this.textareaTarget.scrollHeight}px`
  }
}
